'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _helpers = require('helpers');

var _PaymentStatus = require('helpers/Order/PaymentStatus');

var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);

var _PaymentStatusLabel = require('components/PaymentStatusLabel/PaymentStatusLabel');

var _PaymentStatusLabel2 = _interopRequireDefault(_PaymentStatusLabel);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderListItemView: {
        displayName: 'OrderListItemView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/default/OrderListItemView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

/**
 * @return {string}
 */
function LinkPay(props) {
    var show = props.show,
        onPay = props.onPay,
        getCheckByOrder = props.getCheckByOrder,
        hideAll = props.hideAll,
        lang = props.lang;


    if (show && !hideAll) {
        return _react3.default.createElement(
            'a',
            { href: '#', onClick: onPay, className: 'le-button' },
            lang['store.order_list.pay']
        );
    } else if (hideAll) {
        return _react3.default.createElement('a', null);
    }

    return _react3.default.createElement(
        'a',
        { href: '#', onClick: getCheckByOrder, className: 'le-button' },
        lang['store.order_list.check']
    );
}

var OrderListItemView = _wrapComponent('OrderListItemView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(OrderListItemView, _Component);

    function OrderListItemView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderListItemView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderListItemView.__proto__ || (0, _getPrototypeOf2.default)(OrderListItemView)).call.apply(_ref, [this].concat(args))), _this), _this.onPay = function (event) {
            event.preventDefault();
            _this.props.onPay();
        }, _this.getCheckByOrder = function (e) {
            e.preventDefault();
            (0, _helpers.getCheckByOrder)(_this.props.order);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(OrderListItemView, [{
        key: 'render',
        value: function render() {
            var order = this.props.order || {};
            var date = (0, _moment2.default)(order.time_create);
            /** @type PaymentStatus */
            var paymentStatus = order.paymentStatus != null ? order.paymentStatus.id : null;
            paymentStatus = new _PaymentStatus2.default(paymentStatus);
            var sum = parseFloat(order.sum - order.discount_sum) || 0;

            var _props = this.props,
                lang = _props.lang,
                currency = _props.currency;


            return _react3.default.createElement(
                'div',
                { key: order.id, className: 'order-item order-item-holder' },
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sm-2' },
                        _react3.default.createElement(
                            'div',
                            { className: 'body' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                lang['store.common.order']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'order-number' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/personal/order/' + order.id },
                                    order.order_number
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sm-2' },
                        _react3.default.createElement(
                            'div',
                            { className: 'body' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                lang['store.common.date']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'excerpt' },
                                date.format("DD.MM.YYYY")
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sm-2' },
                        _react3.default.createElement(
                            'div',
                            { className: 'body' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                lang['store.common.status']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'excerpt' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'status-payment' },
                                    _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status })
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sm-3 block-order-sum content-block' },
                        _react3.default.createElement(
                            'div',
                            { className: 'body' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                lang['store.common.sum']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'order-sum' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'price-current' },
                                    _react3.default.createElement(_components2.MoneyValue, {
                                        value: sum,
                                        icon: currency.icon,
                                        iconAfterValue: currency.icon_after_value
                                    })
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sm-3 buttons' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/personal/order/' + order.id, className: 'le-button' },
                            lang['store.common.details']
                        ),
                        _react3.default.createElement(LinkPay, {
                            show: paymentStatus.isPayActionAvaliable(),
                            hideAll: paymentStatus.isOutdated || paymentStatus.isCanceled() || sum === 0,
                            onPay: this.onPay,
                            getCheckByOrder: this.getCheckByOrder,
                            lang: lang
                        })
                    )
                )
            );
        }
    }]);
    return OrderListItemView;
}(_react2.Component), _class.propTypes = {
    order: _react2.PropTypes.object,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp2));

exports.default = OrderListItemView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/OrderList/default/OrderListItemView.jsx
// module id = 762
// module chunks = 0